<script setup>
import { ref, onMounted, computed, watch } from "vue";
import useChatWidget from "../stores/chatWidget";

const $chatWidget = useChatWidget();
const $globalSetting = computed(() => $chatWidget.getGlobalSettings());
const $config = $chatWidget.getConfig;
const $setting = $chatWidget.getSettings;
const $payload = $chatWidget.getPayload();
const $staffs = computed(() => $chatWidget.getStaffs());
const selectedStaff = ref(null);

onMounted(async () => {
  if ($staffs.value.length === 0) {
    await $chatWidget.fetchStaffs();
  }
});

watch(
  () => $payload.value?.service,
  (newService) => {
    if (newService) {
      selectedStaff.value = null;
    }
  },
  { deep: true }
);

const handleStaff = (staff) => {
  selectedStaff.value = staff;

  const tempPayload = $payload;
  tempPayload.staff = staff;
  tempPayload.step = $payload.step + 1;
  $chatWidget.updatePayload(tempPayload);
};
</script>

<template>
  <div id="prebook-chat-component-staff" class="px-4 py-[15px]">
    <div class="inline-flex w-[50px]">
      <img
        :src="$globalSetting?.settings?.business?.full_logo_url"
        :alt="$globalSetting?.settings?.business?.name"
        class="w-full object-contain"
      />
    </div>
    <h2 class="text-[20px]">
      {{ $setting.staff.question }}
    </h2>
    <div class="flex flex-col gap-2.5 py-[10px]">
      <div
        v-for="staff in $staffs"
        :key="staff.staff_id"
        @click="handleStaff(staff)"
        :class="{
          active: selectedStaff && selectedStaff.staff_id === staff.staff_id,
        }"
        class="group transition delay-150 duration-300 ease-in-out hover:bg-gray-200 flex items-center justify-between gap-1.5 border-solid border-[1.5px] border-gray-200 rounded-[8px] p-[12px] cursor-pointer"
      >
        <div class="flex items-center gap-2">
          <div
            class="w-[64px] h-[64px] flex items-center justify-center rounded-full flex-shrink-0"
            :style="{
              'background-color': staff.color,
            }"
          >
            <img
              v-if="staff.profile_image_url"
              :src="staff.profile_image_url"
              :alt="staff.first_name + ' ' + staff.last_name"
              class="w-[64px] h-[64px] object-cover rounded-full border-2 border-white"
            />
            <span v-else class="inline-flex text-[20px] text-white font-medium">
              {{ staff.first_name?.substring(0, 1).toUpperCase() }}
            </span>
          </div>
          <div class="">
            <h3 class="font-medium text-[16px] m-0">
              {{ staff.first_name + " " + staff.last_name }}
            </h3>
            <p class="text-[14px] text-gray-500 mt-0.5 mb-0">
              {{ staff.title }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Transition
    enter-active-class="transition duration-300 ease-out"
    enter-from-class="transform -translate-y-4 opacity-0"
    enter-to-class="transform translate-y-0 opacity-100"
    leave-active-class="transition duration-200 ease-in"
    leave-from-class="transform translate-y-0 opacity-100"
    leave-to-class="transform -translate-y-4 opacity-0"
  >
    <div v-if="selectedStaff?.staff_id" class="p-5 text-right">
      <p class="inline-block bg-gray-200 rounded-[8px] p-4 font-medium m-0">
        <span class="block text-[16px]">{{
          selectedStaff.first_name + " " + selectedStaff.last_name
        }}</span>
        <span class="block text-[14px] font-light">{{
          selectedStaff.title
        }}</span>
      </p>
    </div>
  </Transition>
</template>

<style scoped>
.active,
.active:hover {
  background-color: #1e2939 !important;
  border-color: #1e2939 !important;
  color: #fff;
}
.active p {
  color: #fff !important;
}
</style>
